(() => {
  // app/scripts/product-item-swatch.js
  customElements.define("product-item-swatch", class productDescription extends HTMLElement {
    constructor() {
      super();
      this.currentImage = this.querySelector(".product-image");
      this.swatchItems = this.querySelectorAll(".swatch-item");
      this.swatchItems.forEach((swatch) => {
        swatch.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleImage(swatch);
        });
      });
    }
    toggleImage(element) {
      this.swatchItems.forEach((swatch) => {
        swatch.classList.remove("active");
      });
      element.classList.add("active");
      this.currentImage.innerHTML = element.innerHTML;
    }
  });
})();
